export function pageScrollTop() {
    const display = window.document.body.style.display;
    window.document.body.style.display = 'none';
    window.document.documentElement.scrollTop = 0;
    window.document.body.style.display = display;
}
